import editorRule from '@/components/atoms/editorRule'
import { PortableText } from 'next-sanity'

const Description = ({ text }) => {
  const base =
    'content w-full text-bodyMobile md:text-bodyDesktop text-olive font-chivoMono mt-smallMobile lg:mt-mediumDesktop'
    
  return (
    <div className={base}>
      <PortableText value={text} components={editorRule()} />
    </div>
  )
}

export default Description
